import axios from 'axios';

const api = axios.create({
  baseURL: 'https://zhishentong.net/api',
  timeout: 120000,
  headers: { 'Content-Type': 'application/json' },
});

// 存储 token 的 key
const TOKEN_KEY = 'zhishentong_token';

// 请求拦截器 - 自动添加 token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器 - 处理 401 未认证
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // token 过期或无效，跳转到登录页
      localStorage.removeItem(TOKEN_KEY);
      window.location.href = '/login';
    }
    console.error('API请求失败:', error);
    return Promise.reject(error);
  }
);

// 登录函数
export const login = async (username: string, password: string) => {
  const formData = new FormData();
  formData.append('username', username);
  formData.append('password', password);
  
  const response = await axios.post('http://localhost:8000/token', formData, {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  });
  
  const { access_token } = response.data;
  localStorage.setItem(TOKEN_KEY, access_token);
  return response.data;
};

// 登出函数
export const logout = () => {
  localStorage.removeItem(TOKEN_KEY);
  window.location.href = '/login';
};

// 获取当前用户信息
export const getCurrentUser = async () => {
  const response = await api.get('/me');
  return response.data;
};

export default api;
// 请求拦截器 - 自动添加 token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('zhishentong_token');
    console.log('当前token:', token);  // 添加这行调试
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      console.log('已添加Authorization头');
    } else {
      console.log('没有token');
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
